const AGREEMENT_STATUSES = {
    PROPOSED: 0,
    DECLINED: 1,
    APPROVED: 2,
    EXPIRED: 3,
    ARCHIVED: 4,
};
export { AGREEMENT_STATUSES, };
